export const PRODUCT_PRICE = {
    BASE_PATH: '/product/product-price/',
    GET_ALL: '/product-price',
    GET_BY_CATEGORIES: '/product-price/categories',
    GET_BY_BARCODE: '/product-price/barcode/',
    EDIT: '/product-price/edit/',
    CREATE: '/product-price/create',
    UPDATE: '/product-price/update/',
    DELETE: '/product-price/delete/',
    ADD_NEW_TITLE: 'Add New Product Price',
};
